import {
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  List,
  makeStyles,
  Typography,
} from "@material-ui/core";
import {
  AdminPanelSettings as AdminPanelSettingsIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  AttachMoney as AttachMoneyIcon,
  DeliveryDining as DeliveryDiningIcon,
  Group as GroupIcon,
  Input as InputIcon,
  ListAlt as ListAltIcon,
  Subject as SubjectIcon,
  SwapHoriz as SwapHorizIcon,
  Save as SaveIcon,
  Receipt as ReceiptIcon,
  CreditCard as CreditCardIcon,
  ArrowBack as ArrowBackIcon,
  MenuBook as MenuBookIcon,
} from "@material-ui/icons";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import {
  BarChart as BarChartIcon,
  Package as PackageIcon,
  Settings as SettingsIcon,
  User as UserIcon,
  CornerDownRight as SubItemIcon,
} from "react-feather";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog, Modal } from "src/components";
import { carregarModulos } from "src/store/actions/menus";
import { ativarRecorrencia } from "src/store/actions/usuario";
import * as types from "src/store/types/usuario";
import NavItem from "./NavItem";

const useStyles = makeStyles((theme) => ({
  mobileSidebar: {
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  desktopSidebar: {
    display: "none",
    [theme.breakpoints.down("lg")]: {
      display: "block",
    },
  },
  logoutMobileButton: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
  },
  logoutButton: {
    marginTop: "auto",
    color: theme.palette.text.secondary,
    fontWeight: "medium",
    justifyContent: "flex-start",
    letterSpacing: 0,
    textTransform: "none",
    width: "100%",
    height: "48px",
    "& svg": {
      marginRight: "8px",
    },
  },
}));

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const [menu, setMenu] = useState([]);
  const [subitemsVisible, setSubitemsVisible] = useState("");
  const [selectedSubItem, setSelectedSubItem] = useState("");
  const [formCard, setFormCard] = useState({
    numero_cartao: "",
    validade: "",
    digito: "",
  });
  const [modal, setModal] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { loading, empresa_atual, usuario, permissoes } = useSelector(
    (state) => state.usuario
  );
  const { modulos } = useSelector((state) => state.menus);

  const handleAtivarRecorrencia = () => {
    ativarRecorrencia({
      forma_pagto: modal === "cartao" ? "CARTAO_CREDITO" : "BOLETO",
      numero_cartao: formCard.numero_cartao,
      validade: formCard.validade,
      digito: formCard.digito,
      recorrencia_id: empresa_atual.recorrencia_id,
    });
  };

  const handleChange = (event) => {
    setFormCard({ ...formCard, [event.target.name]: event.target.value });
  };

  const verifyPermission = (
    permissions = [],
    condition,
    val_true,
    val_false
  ) => {
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i] == condition) {
        return val_true;
      }
    }
    return val_false;
  };

  const menus = [
    {
      id: 1,
      href: verifyPermission(permissoes, 1, "/app/dashboard", "#"),
      icon: BarChartIcon,
      title: "Dashboard",
      disabled: verifyPermission(permissoes, 1, false, true),
      permission: 1,
      order: 1,
    },
    {
      id: 2,
      href: verifyPermission(permissoes, 2, "/app/clientes", "#"),
      icon: GroupIcon,
      title: "Clientes",
      disabled: verifyPermission(permissoes, 2, false, true),
      permission: 1,
      order: 2,
    },
    {
      id: 5,
      href: verifyPermission(permissoes, 5, "/app/cashback", "#"),
      icon: SwapHorizIcon,
      title: "Cashback",
      disabled: verifyPermission(permissoes, 5, false, true),
      permission: 1,
      order: 3,
    },
    {
      id: 6,
      href: verifyPermission(permissoes, 6, "/app/produtos", "#"),
      icon: PackageIcon,
      title: "Produtos",
      disabled: verifyPermission(permissoes, 6, false, true),
      order: 4,
      permission: 2,
    },
    {
      id: 7,
      href: verifyPermission(permissoes, 7, "/app/categorias", "#"),
      icon: ListAltIcon,
      title: "Categorias",
      disabled: verifyPermission(permissoes, 7, false, true),
      order: 5,
      permission: 2,
    },
    {
      id: 8,
      href: verifyPermission(permissoes, 8, "/app/complementos", "#"),
      icon: SubjectIcon,
      title: "Complementos",
      disabled: verifyPermission(permissoes, 8, false, true),
      order: 6,
      permission: 2,
    },
    {
      id: 9,
      href: verifyPermission(permissoes, 9, "/app/entregadores", "#"),
      icon: DeliveryDiningIcon,
      title: "Entregadores",
      disabled: verifyPermission(permissoes, 9, false, true),
      order: 7,
      permission: 3,
    },
    {
      id: 10,
      href: verifyPermission(permissoes, 10, "/app/pedidos", "#"),
      icon: AssignmentTurnedInIcon,
      title: "Pedidos",
      disabled: verifyPermission(permissoes, 10, false, true),
      order: 8,
      permission: 3,
    },
    /* {
      icon: AttachMoneyIcon,
      href: "/app/pagamentos",
      title: "Pagamentos",
      order: 9,
      permission: true,
    }, */
    {
      id: 22,
      href: verifyPermission(permissoes, 22, "/app/comanda", "#"),
      icon: MenuBookIcon,
      title: "Comanda",
      disabled: verifyPermission(permissoes, 22, false, true),
      order: 2,
      permission: 3,
    },
    // {
    //   icon: AttachMoneyIcon,
    //   title: "Financeiro",
    //   order: 9,
    //   permission: 4,
    //   subitems: [
    //     {
    //       id: 13,
    //       href: verifyPermission(permissoes, 13, "/app/algumacoisa", "#"),
    //       title: "Alguma coisa lá na frente",
    //       disabled: verifyPermission(permissoes, 13, false, true),
    //     },
    //   ],
    // },
    {
      id: 11,
      href: verifyPermission(permissoes, 11, "/app/usuarios", "#"),
      icon: AdminPanelSettingsIcon,
      title: "Usuários",
      disabled: verifyPermission(permissoes, 11, false, true),
      order: 11,
      permission: 0,
    },
    {
      id: 12,
      href: verifyPermission(permissoes, 12, "/app/configuracoes", "#"),
      icon: SettingsIcon,
      title: "Configurações",
      disabled: verifyPermission(permissoes, 12, false, true),
      order: 12,
      permission: 0,
    },
    {
      id: 4,
      href: "/app/perfil",
      icon: UserIcon,
      title: "Perfil",
      disabled: false,
      order: 10,
      permission: 0,
    },
  ];

  useEffect(() => {
    carregarModulos();
  }, []);

  useEffect(() => {
    if (permissoes === null || !modulos.length) {
      navigate("/app#");
      return;
    }

    let sortedMenu = [];

    menus.forEach((menu) => {
      for (let i = 0; i < modulos.length; i++) {
        if (
          menu.permission === modulos[i].modulo_id ||
          menu.permission === true
        ) {
          sortedMenu = [...sortedMenu, menu];
          break;
        }
      }
    });

    setMenu(sortedMenu);
    navigate(sortedMenu[0].href);
  }, [modulos, permissoes]);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      empresa_atual?.forma_pagto === "CARTAO_CREDITO" &&
      empresa_atual?.recorrencia_cartao === 0
    ) {
      setModal("cartao");
    } else if (empresa_atual?.forma_pagto === "INDEFINIDO") {
      setModal("indefinido");
    } else {
      setModal("");
    }
  }, [empresa_atual]);

  const signOut = () => {
    localStorage.removeItem("token");
    dispatch([
      {
        type: types.USUARIO_SET_USER,
        payload: {},
      },
      {
        type: types.USUARIO_SET_EMPRESAS,
        payload: [],
      },
      {
        type: types.USUARIO_SET_EMPRESA_ATUAL,
        payload: {},
      },
      { type: types.USUARIO_SET_SELECT_EMPRESA, payload: false },
    ]);
    navigate("/");
  };

  const content = (
    <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        style={{
          padding: "16px",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography color="textPrimary" variant="h5">
          {usuario.nome}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {usuario.email}
        </Typography>
      </Box>
      <Divider />
      <Box>
        <List>
          {menu.map((item) => (
            <NavItem
              disabled={item.disabled}
              subitems={item.subitems}
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
              setSubitemsVisible={setSubitemsVisible}
              subitemsVisible={subitemsVisible}
              setSelectedSubItem={setSelectedSubItem}
              selectedSubItem={selectedSubItem}
            />
          ))}
        </List>
        <Box className={classes.logoutMobileButton}>
          <Button className={classes.logoutButton} onClick={signOut}>
            <InputIcon /> Sair
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Box zIndex={1}>
        <Box className={classes.desktopSidebar}>
          <Drawer
            anchor="left"
            onClose={onMobileClose}
            open={openMobile}
            variant="temporary"
            PaperProps={{
              style: {
                width: 256,
              },
            }}
          >
            {content}
          </Drawer>
        </Box>
        <Box className={classes.mobileSidebar}>
          <Drawer
            anchor="left"
            open
            variant="persistent"
            PaperProps={{
              style: {
                width: 256,
                top: 64,
                height: "calc(100% - 64px)",
              },
            }}
          >
            {content}
          </Drawer>
        </Box>
      </Box>
      <Dialog
        visible={modal === "indefinido"}
        title="Escolha uma forma de pagamento"
        contenttext="A empresa ainda não possui nenhum meio de pagamento ativo, por favor, escolha um:"
        buttons={[]}
      >
        <Box display="flex" justifyContent="space-between">
          <Button onClick={handleAtivarRecorrencia}>
            <ReceiptIcon style={{ marginRight: "4px" }} /> Boleto
          </Button>
          <Button onClick={() => setModal("cartao")}>
            <CreditCardIcon style={{ marginRight: "4px" }} /> Cartão de crédito
          </Button>
        </Box>
      </Dialog>
      <Modal open={modal === "cartao"}>
        <Typography variant="h4">
          A empresa ainda não possui um cartão de crédito habilitado!
        </Typography>
        <Typography color="textSecondary">
          Para continuar usando a plataforma, cadastre um
        </Typography>
        <ValidatorForm
          style={{ marginTop: 8 }}
          onSubmit={handleAtivarRecorrencia}
        >
          <Grid container spacing={1}>
            <Grid item sm={8}>
              <NumberFormat
                fullWidth
                customInput={TextValidator}
                label="Número do cartão"
                format="#### #### #### ####"
                name="numero_cartao"
                value={formCard.numero_cartao}
                onValueChange={(value) =>
                  setFormCard({
                    ...formCard,
                    numero_cartao: value.floatValue,
                  })
                }
                variant="outlined"
                margin="dense"
                validators={["required"]}
                errorMessages={["Campo obrigatório"]}
              />
            </Grid>
            <Grid item sm={2}>
              <NumberFormat
                label="Validade"
                customInput={TextValidator}
                format="##/##"
                name="validade"
                value={formCard.validade}
                onChange={handleChange}
                variant="outlined"
                margin="dense"
                validators={["required"]}
                errorMessages={["Campo obrigatório"]}
              />
            </Grid>
            <Grid item sm={2}>
              <TextValidator
                fullWidth
                label="CVV"
                name="digito"
                value={formCard.digito}
                onChange={handleChange}
                variant="outlined"
                margin="dense"
                validators={["required"]}
                errorMessages={["Campo obrigatório"]}
              />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="flex-end" marginTop="8px">
            {empresa_atual?.forma_pagto === "I" && (
              <Button onClick={() => setModal("indefinido")}>
                <ArrowBackIcon /> Voltar
              </Button>
            )}
            <Button type="submit">
              <SaveIcon /> Cadastrar
            </Button>
          </Box>
        </ValidatorForm>
      </Modal>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default DashboardSidebar;
